<template>
  <div class="container is-fullhd">
    <section class="section has-text-centered has-text-weight-semibold">
      {{ sendChapterSectionText }}
    </section>
    <section class="has-text-centered">
      <h1 class="title">Share your progress!</h1>
      <social-sharing
        url="http://usebookman.com"
        :title="title"
        hashtags="bookman,reading,ebook"
        twitter-user="usebookman"
        inline-template>

        <div class="columns is-centered">
          <div class="column is-half">
            <network network="facebook">
              <a class="button">
                <span class="icon">
                  <i class="mdi mdi-facebook"></i>
                </span>
                <span>Facebook</span>
              </a>
            </network>
            <network network="twitter">
              <a class="button">
                <span class="icon">
                  <i class="mdi mdi-twitter"></i>
                </span>
                <span>Twitter</span>
              </a>
            </network>
            <network network="linkedin">
              <a class="button">
                <span class="icon">
                  <i class="mdi mdi-linkedin"></i>
                </span>
                <span>linkedIn</span>
              </a>
            </network>
          </div>
        </div>
      </social-sharing>
    </section>
     <section class="section">
      <figure class="image is-2by1">
        <img src="../assets/undraw_reading_list_4boi.svg">
      </figure>
    </section>
  </div>
</template>

<script>
export default {
  name: 'sendChapter',
  mounted () {
    if (this.$route.query.ebook && this.$route.query.user && this.$route.query.sectionId) {
      this.$store.dispatch('sendNextChapter', { ebookId: this.$route.query.ebook, user: this.$route.query.user, sectionId: this.$route.query.sectionId })
    }
  },
  computed: {
    ebook () {
      return this.$store.getters.getEbook
    },
    playOrder () {
      return this.ebook && this.ebook.playOrder
    },
    sendChapterSectionText () {
      if (this.ebook) {
        if (this.playOrder === -1) {
          if (this.ebook.ebookType === 'discover') {
            return `Great! You've finished reading your sample of ${this.ebook.title}!`
          }
          return `Great! You've finished reading ${this.ebook.title}!`
        }
        return `Great! The next chapter of ${this.ebook.title} will be sent to you by email!`
      }
      return ''
    },
    title () {
      if (this.ebook) {
        if (this.playOrder === -1) {
          if (this.ebook.ebookType === 'discover') {
            return `I've finished reading my sample of ${this.ebook.title} by ${this.ebook.author}!`
          }
          return `I've finished reading ${this.ebook.title} by ${this.ebook.author}!`
        }
        return `I've just finished reading a chapter from ${this.ebook.title} by ${this.ebook.author}!`
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
  span {
    margin-right: 1rem !important;
  }
</style>
